import React, { ReactNode } from "react";
import {
  Box,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import CustomIcon from "../../../public/icons-v1_1";

interface Props {
  label: string;
  children: ReactNode;
  contentProps?: PopoverContentProps;
}

function ButtonizedTooltip({ label, children, contentProps }: Props) {
  return (
    <Popover placement="bottom" trigger="click">
      <PopoverTrigger>
        <Flex gap="4px" alignItems="center" cursor="pointer" className="group">
          <Box
            color={"#8F8F8C"}
            _groupHover={{
              color: "#1272EF",
            }}
            _groupActive={{
              color: "#00417D",
            }}
          >
            <CustomIcon src={"info-circle"} width={16} height={16} />
          </Box>
          <Text
            textStyle={"body-sm-bold"}
            color={"#444444"}
            _groupHover={{
              color: "#1272EF",
            }}
            _groupActive={{
              color: "#00417D",
            }}
          >
            {label}
          </Text>
        </Flex>
      </PopoverTrigger>
      <PopoverContent
        width="fit-content"
        borderRadius="8px"
        p={0}
        bg="#FFFFFF"
        _focus={{ boxShadow: "none" }}
        {...contentProps}
      >
        <PopoverArrow />
        <PopoverBody padding="8px 12px">{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default ButtonizedTooltip;
